// extracted by mini-css-extract-plugin
module.exports = {"container":"SubCategoriesHorizontalList-module__container___3b5rl"};